<ng-container *ngIf="underMaintance">
    <app-under-mainatance></app-under-mainatance>
</ng-container>

<ng-container *ngIf="!underMaintance">
    <router-outlet></router-outlet>
    <ngx-spinner template='<img src="../assets/img/loader.gif" alt="">'>
        <p style="font-size: 20px; color: #721374;margin-top:10px;font-weight: 600;">Loading...</p>
    </ngx-spinner>
</ng-container>